import { combineReducers } from "redux-immutable";
import customerListReducer from "./CustomerList/Reducer";

export default combineReducers({
  customerList: customerListReducer
});
